import { useState } from 'react';
import { useDebounce } from './useDebounce';
import { getTenant, isCurrentUserOnlyDepartmentManager } from './helpers';

const useArchivedPathwayAssignments = ({
  view = 'learner',
  search = '',
  page = 1,
  size = 10,
  platformKey = '',
  refresher = null,
}) => {
  const [assignments, setAssignments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({
    totalItems: 0,
    totalPages: 0,
    currentPage: 1,
    pageSize: 0,
  });

  useDebounce(() => {
    (async () => {
      setLoading(true);
      const tenant = platformKey || getTenant();

      const params = new URLSearchParams({
        platform_key: tenant,
        page_size: size.toString(),
        page: page.toString(),
        ...(search.trim() ? { query: search.trim() } : {}),
        ...(isCurrentUserOnlyDepartmentManager() ? { department_mode: '1' } : {}),
      });

      const baseUrl = process.env.REACT_APP_IBL_DM_URL;
      if (!baseUrl) {
        console.error('API base URL not set');
        setLoading(false);
        return;
      }

      const endpointPath = view === 'group' ? 'group/archive' : 'archive';
      const url = `${baseUrl}/api/catalog/suggestions/pathway/manage/${endpointPath}?${params.toString()}`;

      try {
        const response = await fetch(url, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Token ${localStorage.getItem('dm_token')}`,
          },
        });

        if (!response.ok) throw new Error(`Error fetching: ${response.statusText}`);

        const data = await response.json();
        setAssignments(Array.isArray(data.results) ? data.results : []);
        setPagination({
          totalItems: data.count || 0,
          totalPages: Math.ceil((data.count || 0) / size),
          currentPage: page,
          pageSize: size,
        });
      } catch (error) {
        console.error('Failed fetching pathway archived assignments:', error);
        setAssignments([]);
        setPagination({
          totalItems: 0,
          totalPages: 0,
          currentPage: page,
          pageSize: size,
        });
      } finally {
        setLoading(false);
      }
    })();
  }, 200, [view, search, page, size, platformKey, refresher]);

  return { assignments, loading, pagination };
};

export default useArchivedPathwayAssignments;
